/**
 * Wallet API
 * # Introduction Wallet API is an API for creating and managing Klaytn accounts as well as sending transactions. If you create your Klaytn account using Wallet API, you don't have to manage your private key yourself. Wallet API provides a wallet for safe storage of your Klaytn account private keys that you would need to use BApps. For more details on how to use Wallet API, please refer to this [tutorial](https://docs.klaytnapi.com/v/en/tutorial).  Wallet API can be divided into the Account part, which creates and manages Klaytn accounts, and the Transaction part, which sends different kinds of transactions.  Wallet API creates, deletes and monitors Klaytn accounts and updates the accounts to multisig, and manages all private keys for all accounts registered on KAS.  Wallet API can also create transaction to send it to Klaytn. These include transactions sent from multisig accounts. In case of muiltisig accounts, a transaction will automatically be sent to Klaytn once \\(Threshold\\) is met. For more detail, please refer to this [tutorial](https://docs.klaytnapi.com/v/en/tutorial).  There are mainly two types of transactions: basic transactions and fee delegation transactions. Fee delegation transactions include Global Fee Delegation transaction and user fee deletation transaction. With the Global Fee Delegation transaction scheme, the transaction fee will initially be paid by GroundX and then be charged to you at a later date. With the User Fee Delegation transaction scheme, you create an account that pays the transaction fees on behalf of the users when a transaction.  The functionalities and limits of Wallet API are shown below:  | Version | Item | Description | | :--- | :--- | :--- | | 2.0 | Limits | Supports Cypress(Mainnet), Baobab(Testnet) \\ Doesn't support (Service Chain \\) | |  |  | Doesn't support account management for external custodial keys | |  |  | Doesn't support multisig for RLP encoded transactions | |  | Account management | Create, retrieve and delete account | |  |  | Multisig account update | |  | Managing transaction | [Basic](https://ko.docs.klaytn.com/klaytn/design/transactions/basic) creating and sending transaction | |  |  | [FeeDelegatedWithRatio](https://ko.docs.klaytn.com/klaytn/design/transactions/partial-fee-delegation) creating and sending transaction | |  |  | RLP encoded transaction\\([Legacy](https://ko.docs.klaytn.com/klaytn/design/transactions/basic#txtypelegacytransaction), [Basic](https://ko.docs.klaytn.com/klaytn/design/transactions/basic), [FeeDelegatedWithRatio](https://ko.docs.klaytn.com/klaytn/design/transactions/partial-fee-delegation)\\) creating and sending | |  |  | Managing and sending multisig transactions | |  | Administrator | Manage resource pool\\(create, query pool, delete, retrieve account \\) |
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

const ApiClient = require('../../ApiClient')
const ErrorResponse = require('../model/ErrorResponse')
const FDTransactionResult = require('../model/FDTransactionResult')
const FDUserAccountUpdateTransactionRequest = require('../model/FDUserAccountUpdateTransactionRequest')
const FDUserAnchorTransactionRequest = require('../model/FDUserAnchorTransactionRequest')
const FDUserCancelTransactionRequest = require('../model/FDUserCancelTransactionRequest')
const FDUserContractDeployTransactionRequest = require('../model/FDUserContractDeployTransactionRequest')
const FDUserContractExecutionTransactionRequest = require('../model/FDUserContractExecutionTransactionRequest')
const FDUserProcessRLPRequest = require('../model/FDUserProcessRLPRequest')
const FDUserValueTransferTransactionRequest = require('../model/FDUserValueTransferTransactionRequest')

/**
 * FdtxUser service.
 * @class FdtxUserApi
 * @version 1.0
 */
class FdtxUserApi {
    /**
     * Constructs a new FdtxUserApi.
     * @alias FdtxUserApi
     * @class
     * @param {ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance
    }

    /**
     * Callback function to receive the result of the uFDAccountUpdateTransaction operation.
     * @callback FdtxUserApi~uFDAccountUpdateTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * User Fee Delegation account update transaction
     * Create a transaction for updating the Klaytn account key to another key, using user&#x27;s fee payer account. You can find Klaytn account key types in [Accounts](https://ko.docs.klaytn.com/klaytn/design/accounts).&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; is written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDAccountUpdateTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDAccountUpdateTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/account',
            'PUT',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDAnchorTransaction operation.
     * @callback FdtxUserApi~uFDAnchorTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * User Fee Delegation anchor transaction
     * Create a transaction for anchoring the service chain data on the main chain with the user fee payer account.&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDAnchorTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDAnchorTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/anchor',
            'POST',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDContractDeployTransaction operation.
     * @callback FdtxUserApi~uFDContractDeployTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Contract deploy transaction with user fee delegation
     * Create a transaction for deploying contracts with the fee payer account created by user.&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDContractDeployTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDContractDeployTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/contract/deploy',
            'POST',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDContractExecutionTransaction operation.
     * @callback FdtxUserApi~uFDContractExecutionTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Execution of transaction with user fee delegation
     * Create a transaction that executes contracts deployed with the user fee payer account.&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDContractExecutionTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDContractExecutionTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/contract/execute',
            'POST',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDProcessRLP operation.
     * @callback FdtxUserApi~uFDProcessRLPCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Transaction with a user fee delegation RLP
     * Create transaction using rlp (SigRLP or TxHashRLP). The rlp from the transaction API of Wallet API is in the TxHashRLP format, which includes signature.  You can create a SigRLP without signature easily using caver.&lt;p&gt;&lt;/p&gt; If you want to create a SigRLP for each transaction method on caver, use &#x60;getRLPEncodingForSignature()&#x60;, and &#x60;getRLPEncoding()&#x60; to create TxHashRLP. For SigRLP, you sign with the private key of the &#x60;from&#x60; account, as long as the accounts have been created in the account pool. For more details on SigRLP and TxHashRLP by each transaction type, please refer to [Klaytn Docs](https://docs.klaytn.com/klaytn/design/transactions).  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDProcessRLPCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDProcessRLP(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/rlp',
            'POST',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDUserCancelTransaction operation.
     * @callback FdtxUserApi~uFDUserCancelTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Transaction for cancelling user fee delegation
     * Create a transaction for cancelling a pending transaction that had been sent to Klaytn with the user fee payer account. To cancel, you need either the nonce or the transaction hash.&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60;  and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDUserCancelTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDUserCancelTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user',
            'DELETE',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
    /**
     * Callback function to receive the result of the uFDValueTransferTransaction operation.
     * @callback FdtxUserApi~uFDValueTransferTransactionCallback
     * @param {String} error Error message, if any.
     * @param {FDTransactionResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * User Fee Delegation KLAY transfer transaction
     * Create a transaction for transferring KLAY with memo with the fee payer account created by user.&lt;p&gt;&lt;/p&gt;  To use this API, you need two &#x60;x-krn&#x60; for &#x60;account-pool&#x60; and &#x60;feepayer-pool&#x60;. The values for &#x60;x-krn&#x60; are written separated with a comma, as shown below.&lt;p&gt;&lt;/p&gt;  &#x60;&#x60;&#x60; x-krn: krn:1001:wallet:local:account-pool:{{account-pool-id}},krn:1001:wallet:local:feepayer-pool:{{feepayer-pool-id}} &#x60;&#x60;&#x60;
     * @param {Object} opts Optional parameters
     * @param {FdtxUserApi~uFDValueTransferTransactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link FDTransactionResult}
     */
    uFDValueTransferTransaction(xChainId, opts, callback) {
        opts = opts || {}
        const postBody = opts.body

        const pathParams = {}
        const queryParams = {}
        const headerParams = {
            'x-chain-id': xChainId,
        }
        const formParams = {}

        const authNames = ['basic']
        const contentTypes = ['application/json']
        const accepts = ['application/json']
        const returnType = FDTransactionResult

        return this.apiClient.callApi(
            '/v2/tx/fd-user/value',
            'POST',
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            callback
        )
    }
}
module.exports = FdtxUserApi
